import React from 'react';

function ErrorModal({ visible, title = 'Sorry, something went wrong', message = "Sorry, we're unable to complete your request right now. Please try again in a moment.", primaryLabel = 'Try again', onPrimary, onClose, secondaryLabel, onSecondary }) {
  if (!visible) return null;

  return (
    <div className="avatar-popup-overlay" onClick={onClose}>
      <div className="avatar-popup" onClick={(e) => e.stopPropagation()}>
        <button className="avatar-popup-close" onClick={onClose}>×</button>
        <div className="avatar-popup-content">
          <h3>⚠️ {title}</h3>
          <p style={{ marginBottom: '1rem' }}>{message}</p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '10px' }}>
            {onPrimary && (
              <button className="cta-btn" onClick={onPrimary} style={{ minWidth: 140 }}>{primaryLabel}</button>
            )}
            {onSecondary && (
              <button className="discord-hero-btn" onClick={onSecondary} style={{ minWidth: 140 }}>{secondaryLabel || 'Contact us'}</button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorModal; 